type FilterChip = {
  id: string
  label: string
}

type FilterChipsProps = {
  chips: FilterChip[]
  onRemove: (id: string) => void
  onClearAll?: () => void
  className?: string
}

export const FilterChips = ({ chips, onRemove, onClearAll, className }: FilterChipsProps) => {
  if (chips.length === 0) {
    return null
  }

  return (
    <div className={['market-filter-chips', className].filter(Boolean).join(' ')} aria-label="Активные фильтры">
      {chips.map((chip) => (
        <button
          key={chip.id}
          type="button"
          className="market-filter-chip"
          onClick={() => onRemove(chip.id)}
          aria-label={`Снять фильтр: ${chip.label}`}
        >
          <span>{chip.label}</span>
          <span className="market-filter-chip__remove" aria-hidden="true">
            ×
          </span>
        </button>
      ))}
      {onClearAll && chips.length > 1 ? (
        <button type="button" className="market-filter-chips__clear" onClick={onClearAll}>
          Сбросить все
        </button>
      ) : null}
    </div>
  )
}
